export default "__VITE_ASSET__xQ3IKRaU__"